import { first, memoize } from 'lodash';
import { Provider, Role } from '../graphQL';

export const formatProviderName = ({
  firstName,
  lastName,
  postNominalTitles,
}: Pick<Provider, 'firstName' | 'lastName' | 'postNominalTitles' | 'personalTitle'>) => {
  let name = `${firstName} ${lastName}`;
  if (postNominalTitles) {
    name += `, ${postNominalTitles}`;
  }
  return name;
};

type SuperAdminCheck = Pick<Provider, 'role'> & { organizations: any[] };
export const isProviderSuperAdmin = (provider: SuperAdminCheck) =>
  (provider.role === Role.UniversityAdmin || provider.role === Role.UniversityReportingAdmin) &&
  first(provider.organizations)?.children.length > 0;

export const prettifyRole = memoize((uglyRole: string) => {
  // camelcase -> spaces & capitalize first letter
  return uglyRole.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
});

export const getInitials = ({ firstName, lastName }: Pick<Provider, 'firstName' | 'lastName'>) =>
  `${firstName?.[0] ?? '-'}${lastName?.[0] ?? '-'}`;
